import Vue from "vue";
import VueRouter from "vue-router";
import index from "../views/index.vue";
// import login from "@/views/login";
import register from "@/views/register";
import password from "@/views/password";
import result from "@/views/result";
import home from "@/views/home";
import homeIndex from "@/views/home/record/index";
import homeCreate from "@/views/home/record/create";
import createStaff from "@/views/home/record/createStaff";
import yjIndex from "@/views/home/record/yjIndex";
import yjCreate from "@/views/home/record/yjCreate";
import yjAdd from "@/views/home/record/yjAdd";
import recordDetail from "@/views/home/record/recordDetail";
import recordTableIndex from "@/views/home/recordTable/index";
import setAccount from "@/views/home/setAccount";
//信息更新模块正在开发中
import updateIndex from "@/views/home/update/index";
// import updateDevelop from "@/views/home/update/develop";
import updateCompany from "@/views/home/update/updateCompany";
import updateZz from "@/views/home/update/updateZz";
import updateResult from "@/views/home/update/updateResult";
import updateZzResult from "@/views/home/update/updateZzResult";
import zzEdit from "@/views/home/update/zzEdit";

import store from "../store";
import { getUpdateRecordID } from "@/api/update";
import { Message } from "element-ui";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "index",
    component: index,
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/login"),
  },
  {
    path: "/register",
    name: "register",
    component: register,
  },
  {
    path: "/password",
    name: "password",
    component: password,
  },
  {
    path: "/result",
    name: "result",
    component: result,
  },
  {
    path: "/home",
    name: "home",
    component: home,
    children: [
      {
        path: "record/index",
        name: "homeIndex",
        component: homeIndex,
      },
      {
        path: "record/create",
        name: "homeCreate",
        component: homeCreate,
      },
      {
        path: "record/createStaff",
        name: "createStaff",
        component: createStaff,
      },
      {
        path: "record/yjIndex",
        name: "yjIndex",
        component: yjIndex,
      },
      {
        path: "record/yjCreate",
        name: "yjCreate",
        component: yjCreate,
      },
      {
        path: "record/yjAdd",
        name: "yjAdd",
        component: yjAdd,
      },
      {
        path: "record/recordDetail",
        name: "recordDetail",
        component: recordDetail,
      },
      //以下为 登记表模块
      {
        path: "recordTable/index",
        name: "recordTableIndex",
        component: recordTableIndex,
      },
      //账户设置 模块
      {
        path: "setAccount",
        name: "setAccount",
        component: setAccount,
      },
      //信息更新模块
      {
        path: "update/index",
        name: "updateIndex",
        component: updateIndex,
      },

      //信息更新模块正在开发中
      // {
      //   path: "update/develop",
      //   name: "updateDevelop",
      //   component: updateDevelop,
      // },
      {
        path: "update/updateCompany",
        name: "updateCompany",
        component: updateCompany,
      },
      {
        path: "update/updateZz",
        name: "updateZz",
        component: updateZz,
      },
      {
        path: "update/updateResult",
        name: "updateResult",
        component: updateResult,
      },
      {
        path: "update/updateResult",
        name: "updateResult",
        component: updateResult,
      },
      {
        path: "update/updateZzResult",
        name: "updateZzResult",
        component: updateZzResult,
      },
      {
        path: "update/zzEdit",
        name: "zzEdit",
        component: zzEdit,
      },
    ],
  },
];

const router = new VueRouter({
  // mode: "history", // TODO 建设厅服务器不能用history 模式
  base: process.env.BASE_URL,
  routes,
});

async function beforeEach() {
  let res = await getUpdateRecordID();
  return res;
}

router.beforeEach(async (to, from, next) => {
  const { name } = to;

  if (name === "updateIndex") {
    let res = await beforeEach();
    //判断能不能进行信息变更
    if (!res.record_id) {
      Message({
        type: "error",
        showClose: true,
        message: "请先完成信息登记",
      });
      return false;
    }
  }

  if (
    name !== "login" &&
    name !== "register" &&
    name !== "index" &&
    name !== "password" &&
    name !== "result"
  ) {
    const cabbage = store.state.userinfo || null;
    if (!cabbage) {
      next("/login");
    } else {
      next();
    }
    // console.log(typeof from);
  }
  next();
});

export default router;
